var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroSection',{attrs:{"title":'Ooops! Page Not Found',"title-class":'title is-dark slide-in-text',"subtitle":'SIGKO International',"section-class":'hero is-shapped is-link is-fullheight is-bold'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }